import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=27b9b9a3&functional=true&"
import script from "./TextMessage.vue?vue&type=script&lang=js&"
export * from "./TextMessage.vue?vue&type=script&lang=js&"
import style0 from "./TextMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports